import {Injectable} from "@angular/core";
import {ApiService} from "../../shared/api.service";
import {News} from "../../+news/news.model";
import {Headers, RequestOptions} from "@angular/http";
import {Observable} from "rxjs/Observable";

@Injectable()
export class NewsService {

  private newsUrl = '/api/administration/news';

  private headers = new Headers({ 'Cache-Control': 'no-cache' });

  constructor(private apiService: ApiService){

  }

  getNews(){
    return this.apiService.get(this.newsUrl, { headers : this.headers })
      .map(res => res as News[]);
  }

  getNewsById(id){
    let url = `${this.newsUrl}/${id}`;
    return this.apiService.get(url, { headers : this.headers })
      .map(res => res as News);
  }

  createNews(news: News){
    return this.apiService.post(this.newsUrl,JSON.stringify(news))
      .map(res => res as News);
  }

  updateNews(news: News){
    let url = `${this.newsUrl}/${news['_id']}`;
    return this.apiService.put(url,JSON.stringify(news))
      .map(res => res as News);
  }

  deleteNews(id:string){
    let url = `${this.newsUrl}/${id}`;
    return this.apiService.delete(url);
  }

  /**
   * need to leverage the XHR object directly
   * @param newsId
   * @param files
   * @returns {any}
   * @see https://stackoverflow.com/a/36352446/2878984
   */
  uploadImages(newsId:string, files: FileList){
    let url = `${this.newsUrl}/${newsId}/file`;

    return Observable.create(observer => {
      if(!files){
        observer.next(null);
        return observer.complete();
      }
      let formData:FormData = new FormData();

      Array.from(files).forEach(function (file) {
        formData.append("files[]", file);
      });

      let xhr: XMLHttpRequest = new XMLHttpRequest();

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(JSON.parse(xhr.response));
            observer.complete();
          } else {
            observer.error(xhr.response);
          }
        }
      };

      xhr.open('POST', url, true);
      xhr.send(formData);

    });

  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/+admin-app/shared/news.service.ts